import React from 'react';

export interface HeadLineThirdProps {
  text: string;
  className?: string;
}

const HeadLineThird: React.FC<HeadLineThirdProps> = ({ text, ...props }) => {
  return <h3 {...props}>{text}</h3>;
};
export default HeadLineThird;
